<template>
  <component
    :is="componentName"
    :list="list"
    :formdata-disabled="formdataDisabled"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>
  </component>
</template>

<script>
export const TYPES = {
  BASE_EVENTS: 'base-events',
  BASE_EVENT_FILES: 'base-event-files',
  BASE_EVENT_CRITERIA: 'base-event-criteria',
  BASE_EVENT_PARAMETERS: 'base-event-parameters',
  COLLECTOR_PUBLICATIONS: 'collector-publications',
  OKU_COLLECTOR_PUBLICATIONS: 'oku-collector-publications',
  VPR_PUBLICATIONS: 'vpr-publications',
  PROCEDURES: 'procedures',
  COLLECTOR_PARTICIPANTS: 'collector-participants',
  COLLECTOR_VARIANTS: 'collector-variants',
  COLLECTOR_CRITERIA: 'collector-criteria',
  EVENT_HISTORY: 'event-history',
  FILES: 'files',
  FORM_DATA: 'form-data',
  FORM_TEMPLATES: 'form-templates',
  FORMS_HANDBOOK: 'forms-handbook',
  MARKS: 'marks',
  MUN_MEH_LOGS: 'munmeh-logs',
  MUN_MEH_CURATOR_FORMS: 'munmeh-curator-forms',
  MUN_MEH_EXPERT_FORMS: 'munmeh-expert-forms',
  NOTIFICATION_BANNERS: 'notification-banners',
  NOTIFICATION_PAGES: 'notification-pages',
  PARTICIPANTS: 'participants',
  PARTICIPANTS_USERS: 'participants-users',
  PASSPORT_LIST: 'passport',
  PASSPORT_TEMPLATES: 'passport-templates',
  PASSPORT_SCHOOLS: 'passport-schools',
  PASSPORT_SCHOOL_LEADS: 'passport-school-leads',
  PERMISSION_APPLICATIONS: 'permission-applications',
  PERMISSION_GROUPS: 'permission-groups',
  PERMISSION_INFO_MODELS: 'permission-info-models',
  PERMISSIONS: 'permissions',
  PERMISSION_TYPES: 'permission-types',
  PROFILE_PERMISSIONS: 'profile-permissions',
  PUBLICATIONS: 'publications',
  PUBLICATION_MUN_MEH: 'publication-munmeh',
  PUBLICATION_DATA_COLLECTIONS: 'publication-data-collections',
  PUBLICATIONS_USER_AVAILABLE: 'publications-user-available',
  PUBLICATION_STORAGE: 'publication-storage',
  PUBLICATION_STORAGE_FILES: 'publication-storage-files',
  PUBLICATION_STORAGE_FILES_HISTORY: 'publication-storage-files-history',
  PUBLICATION_FORMDATA: 'publication-formdata',
  PUBLICATION_FORMDATA_ATE_NOT_STARTED: 'publication-formdata-ate-not-started',
  PUBLICATION_FORMDATA_HISTORY: 'publication-formdata-history',
  PUBLICATION_FORMDATA_REVISIONS: 'publication-formdata-revisions',
  REGIONS: 'regions',
  REPORTS: 'reports',
  ROADMAPS: 'roadmaps',
  ROADMAP_DIRECTIONS: 'roadmap-directions',
  SCHOOLS: 'schools',
  MUNICIPALITIES: 'municipalities',
  TOPICS: 'topics',
  SESSIONS: 'sessions',
  SCHEDULER: 'scheduler',
  USERS: 'users',
  USERS_ACTIONS: 'users-actions',
  USERS_PARTICIPATIONS: 'users-participants',
  USERS_HISTORY: 'users-history',
}

const getComopnent = ({ type }) => {
  switch (type) {
    case TYPES.BASE_EVENTS:
      return () => import(
        /* webpackChunkName: "b-table-common.base-events" */
        './BTableCommon/BTableBaseEvents.vue'
      )

    case TYPES.BASE_EVENT_FILES:
      return () => import(
        /* webpackChunkName: "b-table-common.base-events.files" */
        './BTableCommon/BTableBaseEventFiles.vue'
      )

    case TYPES.BASE_EVENT_CRITERIA:
      return () => import(
        /* webpackChunkName: "b-table-common.base-events.criteria" */
        './BTableCommon/BTableBaseEventCriteria.vue'
      )

    case TYPES.BASE_EVENT_PARAMETERS:
      return () => import(
        /* webpackChunkName: "b-table-common.base-events.parameters" */
        './BTableCommon/BTableBaseEventParameters.vue'
      )

    case TYPES.FORM_DATA:
      return () => import(
        /* webpackChunkName: "b-table-common.form-data" */
        './BTableCommon/BTableFormData.vue'
      )

    case TYPES.EVENT_HISTORY:
      return () => import(
        /* webpackChunkName: "b-table-common.event-history" */
        './BTableCommon/BTableEventHistory.vue'
      )

    case TYPES.FILES:
      return () => import(
        /* webpackChunkName: "b-table-common.files" */
        './BTableCommon/BTableFiles.vue'
      )

    case TYPES.FORM_TEMPLATES:
      return () => import(
        /* webpackChunkName: "b-table-common.form-templates" */
        './BTableCommon/BTableFormTemplates.vue'
      )

    case TYPES.FORMS_HANDBOOK:
      return () => import(
        /* webpackChunkName: "b-table-common.forms-handbook" */
        './BTableCommon/BTableFormsHandbook.vue'
      )

    case TYPES.MARKS:
      return () => import(
        /* webpackChunkName: "b-table-common.marks" */
        './BTableCommon/BTableMarks.vue'
      )

    case TYPES.MUN_MEH_LOGS:
      return () => import(
        /* webpackChunkName: "b-table-common.munmeh-logs" */
        './BTableCommon/BTableMunMehLogs.vue'
      )

    case TYPES.MUN_MEH_CURATOR_FORMS:
      return () => import(
        /* webpackChunkName: "b-table-common.munmeh-curator-forms" */
        './BTableCommon/BTableMunMehCuratorForms.vue'
      )

    case TYPES.MUN_MEH_EXPERT_FORMS:
      return () => import(
        /* webpackChunkName: "b-table-common.munmeh-expert-forms" */
        './BTableCommon/BTableMunMehExpertForms.vue'
      )

    case TYPES.NOTIFICATION_BANNERS:
      return () => import(
        /* webpackChunkName: "b-table-common.notification-banners" */
        './BTableCommon/BTableNotificationBanners.vue'
      )

    case TYPES.NOTIFICATION_PAGES:
      return () => import(
        /* webpackChunkName: "b-table-common.notification-banners" */
        './BTableCommon/BTableNotificationPages.vue'
      )

    case TYPES.PARTICIPANTS:
      return () => import(
        /* webpackChunkName: "b-table-common.participants" */
        './BTableCommon/BTableParticipants.vue'
      )

    case TYPES.PARTICIPANTS_USERS:
      return () => import(
        /* webpackChunkName: "b-table-common.participants-users" */
        './BTableCommon/BTableUsers.vue'
      )

    case TYPES.PASSPORT_LIST:
      return () => import(
        /* webpackChunkName: "b-table-common.passport-templates" */
        './BTableCommon/BTablePassportsList.vue'
      )

    case TYPES.PASSPORT_TEMPLATES:
      return () => import(
        /* webpackChunkName: "b-table-common.passport-templates" */
        './BTableCommon/BTablePassportTemplates.vue'
      )

    case TYPES.SCHEDULER:
      return () => import(
        /* webpackChunkName: "b-table-common.scheduler" */
        './BTableCommon/BTableScheduler.vue'
      )

    case TYPES.PERMISSION_APPLICATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.permission-applications" */
        './BTableCommon/BTablePermissionApplications.vue'
      )

    case TYPES.PERMISSION_GROUPS:
      return () => import(
        /* webpackChunkName: "b-table-common.permission-groups" */
        './BTableCommon/BTablePermissionGroups.vue'
      )

    case TYPES.PERMISSION_INFO_MODELS:
      return () => import(
        /* webpackChunkName: "b-table-common.permission-infoModels" */
        './BTableCommon/BTablePermissionInfoModels.vue'
      )

    case TYPES.PERMISSIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.permissions" */
        './BTableCommon/BTablePermissions.vue'
      )

    case TYPES.PERMISSION_TYPES:
      return () => import(
        /* webpackChunkName: "b-table-common.permission-types" */
        './BTableCommon/BTablePermissionTypes.vue'
      )

    case TYPES.PROFILE_PERMISSIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.profile-permissions" */
        './BTableCommon/BTableProfilePermissions.vue'
      )

    case TYPES.PUBLICATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.publications" */
        './BTableCommon/BTablePublications.vue'
      )

    case TYPES.COLLECTOR_PUBLICATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-publications" */
        './BTableCommon/BTableCollectorPublications.vue'
      )

    case TYPES.OKU_COLLECTOR_PUBLICATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-publications" */
        './BTableCommon/BTableOKUCollectorPublications.vue'
      )

    case TYPES.VPR_PUBLICATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-publications" */
        './BTableCommon/BTableVPRPublications.vue'
      )

    case TYPES.PROCEDURES:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-publications" */
        './BTableCommon/BTableProcedures.vue'
      )

    case TYPES.COLLECTOR_PARTICIPANTS:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-participants" */
        './BTableCommon/BTableCollectorParticipants.vue'
      )

    case TYPES.COLLECTOR_VARIANTS:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-variants" */
        './BTableCommon/BTableCollectorVariants.vue'
      )

    case TYPES.COLLECTOR_CRITERIA:
      return () => import(
        /* webpackChunkName: "b-table-common.collector-criteria" */
        './BTableCommon/BTableCollectorCriteria.vue'
      )
    case TYPES.PUBLICATION_MUN_MEH:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-munmeh" */
        './BTableCommon/BTablePublicationMunMeh.vue'
      )

    case TYPES.PUBLICATION_DATA_COLLECTIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-data-collections" */
        './BTableCommon/BTablePublicationDataCollections.vue'
      )

    case TYPES.PUBLICATIONS_USER_AVAILABLE:
      return () => import(
        /* webpackChunkName: "b-table-common.publications-user-available" */
        './BTableCommon/BTablePublicationsAvailableForUser.vue'
      )

    case TYPES.PUBLICATION_STORAGE:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-storage" */
        './BTableCommon/BTablePublicationStorage.vue'
      )

    case TYPES.PUBLICATION_STORAGE_FILES:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-storage-files" */
        './BTableCommon/BTablePublicationStorageFiles.vue'
      )

    case TYPES.PUBLICATION_STORAGE_FILES_HISTORY:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-storage-files-history" */
        './BTableCommon/BTablePublicationStorageFilesHistory.vue'
      )

    case TYPES.PUBLICATION_FORMDATA:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-formdata" */
        './BTableCommon/BTablePublicationFormdata.vue'
      )

    case TYPES.PUBLICATION_FORMDATA_ATE_NOT_STARTED:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-formdata-ate-not-started" */
        './BTableCommon/BTablePublicationFormdataAteNotStarted.vue'
      )

    case TYPES.PUBLICATION_FORMDATA_HISTORY:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-formdata-history" */
        './BTableCommon/BTablePublicationFormdataHistory.vue'
      )

    case TYPES.PUBLICATION_FORMDATA_REVISIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.publication-formdata-revisions" */
        './BTableCommon/BTablePublicationFormdataRevisions.vue'
      )

    case TYPES.REPORTS:
      return () => import(
        /* webpackChunkName: "b-table-common.reports" */
        './BTableCommon/BTableReports.vue'
      )

    case TYPES.ROADMAPS:
      return () => import(
        /* webpackChunkName: "b-table-common.roadmaps" */
        './BTableCommon/BTableRoadmaps.vue'
      )

    case TYPES.ROADMAP_DIRECTIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.roadmap-directions" */
        './BTableCommon/BTableRoadmapDirections.vue'
      )

    case TYPES.REGIONS:
    case TYPES.SCHOOLS:
    case TYPES.MUNICIPALITIES:
      return () => import(
        /* webpackChunkName: "b-table-common.regions" */
        './BTableCommon/BTableRegions.vue'
      )

    case TYPES.TOPICS:
      return () => import(
        /* webpackChunkName: "b-table-common.topics" */
        './BTableCommon/BTableTopics.vue'
      )

    case TYPES.SESSIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.sessions" */
        './BTableCommon/BTableSessions.vue'
      )

    case TYPES.USERS:
      return () => import(
        /* webpackChunkName: "b-table-common.users" */
        './BTableCommon/BTableUsers.vue'
      )

    case TYPES.USERS_ACTIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.users-actions" */
        './BTableCommon/BTableUsersActions.vue'
      )

    case TYPES.USERS_PARTICIPATIONS:
      return () => import(
        /* webpackChunkName: "b-table-common.users-participants" */
        './BTableCommon/BTableUsersParticipants.vue'
      )

    case TYPES.USERS_HISTORY:
      return () => import(
        /* webpackChunkName: "b-table-common.users-history" */
        './BTableCommon/BTableUsersHistory.vue'
      )

    default:
      return process.env.NODE_ENV === 'development'
        && {
          functional: true,
          render: (h) => h(
            'div',
            {
              class: 'red white--text align-center justify-center',
              style: 'height: 100%; display: flex;',
            },
            `Type "${type}" <b-table-common /> not supported`,
          ),
        }
  }
}

export default {
  name: 'BTableCommon',
  $_veeValidate: {
    value() {
      return this.list
    },
    name() {
      return this.$attrs.name
    },
  },
  inheritAttrs: false,
  props: {
    list: Array,
    type: {
      type: String,
      required: true,
      validator: (prop) => Object.values(TYPES).includes(prop),
    },
    formdataDisabled: Boolean,
  },
  computed: {
    componentName() {
      return getComopnent(this)
    },
  },
}
</script>
